import { ua } from '../../../../util/user-agent';
import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(Alert,$scope,ShowNoteModal,$timeout) {
        this.Alert = Alert;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ShowNoteModal=ShowNoteModal;
    }
    
    
     $onInit() {
        const format = date => new Date(date).toString().slice(4, 24);
        this.sharedNotes.forEach(note => note.createdOnDisplay = format(note.createdOn));

        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(()=>{
                this.Alert('success', 'global.data_copied')
            })
        })
    }
    
    showNote(corporateNote){
		this.ShowNoteModal(corporateNote.note);
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-notes.controller.js